module.exports = __webpack_public_path__ + "img/Cool_03.3e7bd777.png";